<div appFocusNearest *isLoading="merkmalTree === null">
  <div class="sticky-header">
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="search-bar">
      <div class="search-input-wrapper">
        <input 
          class="form-control" 
          id="search-term" 
          formControlName="searchTerm" 
          type="text"
          [placeholder]="'dialog.searchTerm' | translate"
          [attr.aria-label]="'dialog.searchTerm' | translate"
        />
      </div>
      <button
        class="btn btn-default treeview-btn"
        type="submit"
        [title]="'action.find' | translate"
        [attr.aria-label]="'action.find' | translate"
      >
        <i class="fas fa-search" aria-hidden="true"></i>
      </button>
      <button
        class="btn btn-default treeview-btn"
        (click)="prev()"
        [disabled]="!hasMatches"
        type="button"
        [title]="'action.previous' | translate"
        [attr.aria-label]="'action.previous' | translate"
      >
        <i class="fas fa-arrow-circle-up" aria-hidden="true"></i>
      </button>
      <button
        class="btn btn-default treeview-btn"
        (click)="next()"
        [disabled]="!hasMatches"
        type="button"
        [title]="'action.next' | translate"
        [attr.aria-label]="'action.next' | translate"
      >
        <i class="fas fa-arrow-circle-down" aria-hidden="true"></i>
      </button>
    </form>
  </div>
  <div class="select-tree-wrapper">
    <kendo-treeview
      class="select-tree"
      [nodes]="merkmalTree"
      textField="name"
      childrenField="items"
      kendoTreeViewExpandable
      kendoTreeViewSelectable
      kendoTreeViewHierarchyBinding
      (selectionChange)="onSelectionChange($event)"
      [(expandedKeys)]="expandedKeys"
      [expandBy]="'hierarchy'"
    >
      <ng-template kendoTreeViewNodeTemplate let-dataItem>
        <ng-container *ngIf="dataItem.key; else hierarchy">
          <ng-container *ngIf="getCheckboxState(dataItem.hierarchy, dataItem.name) as cbState">
            <label
              *ngIf="isMultiselectable"
              class="{{ dataItem.hierarchy }} select-tree-item"
              [ngClass]="{
                highlight: matchedNode === dataItem.hierarchy,
                link: true,
                'not-allowed': dataItem.isLocked,
                disabled: dataItem.isDisabled
              }"
            >
              <input
                #checkboxRef
                type="checkbox"
                class="k-checkbox"
                id="L{{ dataItem.key }}"
                [class.indeterminate]="cbState.indeterminate"
                [checked]="cbState.checked"
                [attr.aria-label]="cbState.ariaLabel"
                [title]="cbState.title"
                (click)="toggleIsChecked(dataItem.hierarchy, checkboxRef.checked)"
              />
              <span>{{ dataItem.name }} </span>
              <span class="merkmal-key">({{ dataItem.key }})</span>
              <span *ngIf="dataItem.isLocked" [title]="dataItem.lockedBy" [attr.aria-label]="dataItem.lockedBy">
                <i class="fas fa-lock fa-sm" aria-hidden="true"></i>
              </span>
            </label>
            <span
              *ngIf="!isMultiselectable"
              class="{{ dataItem.hierarchy }} select-tree-item"
              [ngClass]="{
                highlight: matchedNode === dataItem.hierarchy,
                link: true,
                'not-allowed': dataItem.isLocked,
                disabled: dataItem.isDisabled
              }"
            >
              <span>{{ dataItem.name }} </span>
              <span class="merkmal-key">({{ dataItem.key }})</span>
              <span *ngIf="dataItem.isLocked" [title]="dataItem.lockedBy" [attr.aria-label]="dataItem.lockedBy">
                <i class="fas fa-lock fa-sm" aria-hidden="true"></i>
              </span>
            </span>
          </ng-container>
        </ng-container>
        <ng-template #hierarchy>
          <!--<input
            #checkboxHierarchyRef
            *ngIf="isMultiselectable"
            type="checkbox"
            class="k-checkbox"
            id="L{{ dataItem.hierarchy }}"
            [checked]="merkmale | isMerkmalChecked: alleMerkmale : dataItem.hierarchy : showAllMerkmale"
            (click)="toggleIsChecked(dataItem.hierarchy, checkboxHierarchyRef.checked)"
          />
          <label
            class="{{ dataItem.hierarchy }}"
            attr.for="L{{ dataItem.hierarchy }}"
            [ngClass]="{ highlight: matchedNode === dataItem.hierarchy }"
          >
            {{ dataItem.name }}
          </label>-->
        </ng-template>
      </ng-template>
    </kendo-treeview>
  </div>
  <div class="uba-button-group">
    <button *ngIf="showApplyButton" type="button" class="btn btn-primary" (click)="applyMerkmale()">
      {{ 'action.apply' | translate }}
    </button>
  </div>
</div>